import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
export const getRequesting = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.requesting;
};
export const selectReports = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.receiptReports;
};
export const getFeatures = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.features;
};
export const selectUsers = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.users;
};
export const selectMachines = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.machines;
};
export const selectAlerts = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.alerts;
};
export const selectEquipments = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.qrs;
};
export const selectReportTitles = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.reportTitles;
};
export const selectDepartments = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.departments;
};
export const selectToolbox = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.toolbox;
};
export const selectToolboxTitles = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.toolboxTitles;
};
export const selectAllReports = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.reports;
};
export const selectJobPacks = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.jobpacks;
};
export const selectMonth = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.month;
};
export const selectYear = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.year;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile){
        return UserProfile_reducer.profile.profile;
    }
    else return false;
};
export const selectUserDeviceInfo = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.userDeviceInfo;
};
export const selectAllAreas = ({ CompanyAnalytics_reducer }) => {
    return CompanyAnalytics_reducer.areas;
};
export const selectDept = createSelector(
    [ selectProfile],
    (profile = false) => {
        if(profile){
            return profile.departments
        }else return null
    }
);
export const selectAreas = createSelector(
    [ selectProfile],
    (profile = false) => {
        if(profile){
            return profile.areas
        }else return null
    }
);
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["help"];
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config ? config.read : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.delete : true;
    }
);
export const selectFeature = createSelector([getFeatures], (features) => {
    if (
        features === false ||
        typeof features === "undefined" ||
        features === null
    ) {
        return [];
    }

    let regFeatures = Object.keys(features).map((e) => {
        return features[e];
    });
    return regFeatures;
});

export const selectReceiptReports = createSelector(
    [selectReports, selectYear, selectMonth],
    (receiptReports, year, month) => {
        let offlineRepCount = 0;
        let onlineRepCount = 0;
        let offlineJobPackCount = 0;
        let onlineJobPackCount = 0;
        let totalReports;
        if (receiptReports) {
            totalReports = _.compact(
                _.flattenDeep(
                    Object.keys(receiptReports).map((e) => {
                        let userReports =
                            _.get(receiptReports[e], "receipts") || null;
                        let year1 = _.get(userReports, year) || null;
                        let month1 = _.get(year1, month) || null;
                        if (month1) return { uid: e, month1 };
                        else return null;
                    })
                )
            );
        }
        if (receiptReports) {
            totalReports = _.compact(
                _.flattenDeep(
                    totalReports &&
                        totalReports.map((e) => {
                            return getFlattenedTableReports(e.month1, e.uid);
                        })
                )
            );
        }
        _.compact(
            totalReports &&
                totalReports.map((e) => {
                    if (
                        e.connection_status === "offline" &&
                        e.subject_name === "reports"
                    ) {
                        return (offlineRepCount = offlineRepCount + 1);
                    } else if (
                        e.connection_status === "offline" &&
                        e.subject_name !== "reports"
                    ) {
                        return (offlineJobPackCount = offlineJobPackCount + 1);
                    }
                    return null;
                })
        );
        _.compact(
            totalReports &&
                totalReports.map((e) => {
                    if (
                        e.connection_status === "online" &&
                        e.subject_name === "reports"
                    ) {
                        return (onlineRepCount = onlineRepCount + 1);
                    } else if (
                        e.connection_status === "online" &&
                        e.subject_name !== "reports"
                    ) {
                        return (onlineJobPackCount = onlineJobPackCount + 1);
                    }
                    return null;
                })
        );
        const data = {
            labels: [
                "Reports Created Online",
                "Reports Created Offline",
                "JobPack Reports Created Offline",
                "JobPack Reports Created Online",
            ],
            datasets: [
                {
                    data: [
                        onlineRepCount,
                        offlineRepCount,
                        offlineJobPackCount,
                        onlineJobPackCount,
                    ],
                    backgroundColor: [
                        "#FF6384",
                        "#36A2EB",
                        "#FFCE56",
                        "#008000",
                    ],
                    hoverBackgroundColor: [
                        "#FF6384",
                        "#36A2EB",
                        "#FFCE56",
                        "#008000",
                    ],
                },
            ],
        };
        return data;
    }
);
const getFlattenedTableReports = (userReports, uid) => {
    if (userReports)
        return (
            userReports &&
            Object.keys(userReports).map((e) => {
                if (e !== "holiday_request") {
                    return getTableReciepts(userReports[e], uid);
                } else return null;
            })
        );
};
export const getTableReciepts = (reciepts, uid) => {
    return Object.keys(reciepts).map((e) => {
        let connection_status =
            _.get(reciepts[e], "connection_status") || "online";
        let subject_name = _.get(reciepts[e], "subject_name") || null;
        return {
            connection_status,
            subject_name,
        };
    });
};
export const selectFirstAiders = createSelector([selectUsers,selectAllAreas, selectAreas, selectDept], 
    (users, departments = false, allAr = false , userAreas = false, userDepts = false) => {
    let count = 0;
    if (users) {

        //get users belonging to logged in user areas & depts    
        let allAreas = allAr && Object.values(allAr).map((e)=> { return e })
        let allDepartments = departments && Object.values(departments).map((e)=> { return e })
        
        if(userAreas === false){
            userAreas = allAreas
        }
        if(userDepts === false){
            userDepts = allDepartments
        }
        let validationArea = []
        let validationDept = []
        let totalUsers = _.compact(
            Object.keys(users).map(e => {
                let refArray = []
                let deleted =
                    _.get(users[e], "profile.deleted") || false;
                let areas = 
                    _.get(users[e], "profile.areas") || null
                let departments = 
                    _.get(users[e], "profile.departments") || null 

                if(areas === null ){
                    validationArea = _.intersection(allAreas,userAreas)
                }else{
                    validationArea = _.intersection(areas,userAreas)
                }

                if(departments === null){
                    validationDept = _.intersection(allDepartments,userDepts)
                }else {
                    validationDept = _.intersection(departments,userDepts)
                } 

                if (!deleted && validationArea.length !== 0 && validationDept.length !== 0) {
                    refArray.push( users[e] )
                    return users[e];
                        
                } else return null;
            })
        );
        Object.values(totalUsers).map((e) => {
            if (e.profile.deleted === false) {
                Object.values(e.profile.qualifications_per_user).map((f) => {
                    if (
                        f.qualification_id === "000037" &&
                        f.qualification_exp_date !== "N/A" &&
                        f.qualification_exp_date !== "Req."
                    ) {
                        count = count + 1;
                    }
                    return null;
                });
            }
            return null;
        });
    } else return false;
    return count;
});

export const selectTitles = createSelector(
    [selectReportTitles, selectUsers, selectMonth, selectYear],
    (reports, users, month, year) => {
        let count = 0;
        let reportArray = [];
        let keyArray = [];
        let refArray = [];
        let finalArray = [];
        if (reports) {
            Object.values(reports).map((e) => {
                reportArray.push(e);
                return null;
            });
            Object.keys(reports).map((e) => {
                keyArray.push(e);
                return null;
            });
            if (users) {
                Object.values(users).map((k) => {
                    if (
                        typeof k.receipts !== "undefined" &&
                        k.receipts !== null
                    ) {
                        Object.entries(k.receipts).map((e) => {
                            if (e[0] === year) {
                                Object.entries(e[1]).map((f) => {
                                    if (f[0] === month) {
                                        Object.values(f[1]).map((g) => {
                                            Object.values(g).map((h) => {
                                                refArray.push(h);
                                                return null;
                                            });
                                            return null;
                                        });
                                    }
                                    return null;
                                });
                            }
                            return null;
                        });
                    }
                    return null;
                });
            }
        } else return false;
        keyArray &&
            keyArray.map((z) => {
                count = 0;
                refArray &&
                    refArray.map((a) => {
                        if (z === a.report_type) {
                            count = count + 1;
                        }
                        return null;
                    });
                finalArray.push(count);
                return null;
            });

        const data = {
            labels: reportArray,
            datasets: [
                {
                    label: "",
                    backgroundColor: "rgba(2,136,204)",
                    borderColor: "rgba(0,0,0,1)",
                    borderWidth: 2,
                    data: finalArray,
                },
            ],
        };
        return data;
    }
);

export const selectDepartmentsFilter = createSelector(
    [selectDepartments, selectUsers, selectMonth, selectYear],
    (departments, users, month, year) => {
        let count = 0;
        let reportArray = [];
        let refArray = [];
        let finalArray = [];
        if (departments) {
            Object.values(departments).map((e) => {
                reportArray.push(e);
                return null;
            });
            if (users) {
                Object.values(users).map((k) => {
                    if (
                        typeof k.receipts !== "undefined" &&
                        k.receipts !== null
                    ) {
                        Object.entries(k.receipts).map((e) => {
                            if (e[0] === year) {
                                Object.entries(e[1]).map((f) => {
                                    if (f[0] === month) {
                                        Object.values(f[1]).map((g) => {
                                            Object.values(g).map((h) => {
                                                refArray.push(h);
                                                return null;
                                            });
                                            return null;
                                        });
                                    }
                                    return null;
                                });
                            }
                            return null;
                        });
                    }
                    return null;
                });
            }
        } else return false;
        reportArray &&
            reportArray.map((z) => {
                count = 0;
                refArray &&
                    refArray.map((a) => {
                        if (z === a.departments) {
                            count = count + 1;
                        }
                        return null;
                    });
                finalArray.push(count);
                return null;
            });

        var x = Math.floor(Math.random() * 256);
        var y = Math.floor(Math.random() * 256);
        var z = Math.floor(Math.random() * 256);
        const data = {
            labels: reportArray,
            datasets: [
                {
                    label: "",
                    backgroundColor: "rgb(" + x + "," + y + "," + z + ")",
                    borderColor: "rgba(0,0,0,1)",
                    borderWidth: 2,
                    data: finalArray,
                },
            ],
        };
        return data;
    }
);

export const selectToolboxFilter = createSelector(
    [selectToolbox, selectToolboxTitles],
    (toolbox, titles) => {

        let count = 0;
        let reportArray = [];
        let refArray = [];
        let finalArray = [];
        if (toolbox && titles) {
            Object.values(titles).map((e) => {
                reportArray.push(e);
                return null;
            });

            Object.values(toolbox).map((e) => {
                if (typeof e.reports !== "undefined" && e.reports !== null)
                    refArray.push(e);
                return null;
            });

            reportArray &&
                reportArray.map((z) => {
                    count = 0;
                    refArray &&
                        refArray.map((e) => {
                            if (z === e.profile.category) {
                                let countHelp = Object.values(e.reports).length;
                                count = count + countHelp;
                            }
                            return null;
                        });
                    finalArray.push(count);
                    return null;
                });
        } else return false;
        var x = Math.floor(Math.random() * 256);
        var y = Math.floor(Math.random() * 256);
        var z = Math.floor(Math.random() * 256);
        const data = {
            labels: reportArray,
            datasets: [
                {
                    label: "",
                    backgroundColor: "rgb(" + x + "," + y + "," + z + ")",
                    borderColor: "rgba(0,0,0,1)",
                    borderWidth: 2,
                    data: finalArray,
                },
            ],
        };
        return data;
    }
);

export const selectJobpacksFilter = createSelector(
    [selectJobPacks],
    (jobpacks) => {
        let count = 0;
        let reportArray = [
            "jan",
            "feb",
            "mar",
            "apr",
            "may",
            "jun",
            "jul",
            "aug",
            "sep",
            "oct",
            "nov",
            "dec",
        ];
        let keyArray = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        let finalArray = [];
        if (jobpacks) {
            reportArray &&
                reportArray.map((k) => {
                    count = 0;
                    Object.entries(jobpacks).map((e) => {
                        if (e[0] === k) {
                            let countHelp = Object.values(e[1]).length;
                            count = count + countHelp;
                        }
                        return null;
                    });
                    finalArray.push(count);
                    return null;
                });
        } else return false;

        var x = Math.floor(Math.random() * 256);
        var y = Math.floor(Math.random() * 256);
        var z = Math.floor(Math.random() * 256);
        const data = {
            labels: keyArray,
            datasets: [
                {
                    label: "",
                    backgroundColor: "rgb(" + x + "," + y + "," + z + ")",
                    borderColor: "rgba(0,0,0,1)",
                    borderWidth: 2,
                    data: finalArray,
                },
            ],
        };
        return data;
    }
);

export const selectLastAccident = createSelector([selectUsers], (users) => {
    let recent = "";
    let timeref = "";
    if (users) {
        Object.values(users).map((k) => {
            if (
                k.profile.deleted === false &&
                typeof k.receipts !== "undefined" &&
                k.receipts !== null
            ) {
                Object.values(k.receipts).map((e) => {
                    Object.values(e).map((f) => {
                        Object.values(f).map((g) => {
                            Object.values(g).map((h) => {
                                let refObj = h;
                                let refdate = moment(
                                    h.timestamp,
                                    "DD-MM-YYYY HH:mm:ss"
                                );
                                refObj["utc"] = parseInt(
                                    (
                                        new Date(refdate).getTime() / 1000
                                    ).toFixed(0)
                                );
                                if (h.report_type === "incident_and_accident") {
                                    if (h.utc > recent) {
                                        timeref = "";
                                        recent = h.utc;
                                        timeref = h.timestamp;
                                    }
                                }
                                return null;
                            });
                            return null;
                        });
                        return null;
                    });
                    return null;
                });
            }
            return null;
        });
    } else return false;
    return timeref;
});

export const selectVehicleAlerts = createSelector(
    [selectAlerts, selectMonth, selectYear],
    (alert, month, year) => {
        let count = 0;
        if (alert) {
            Object.values(alert).map((e) => {
                let modalMonth = "";
                let monthref = e.timestamp.split("-");
                let conditionCheck = monthref[1];
                if (conditionCheck === "01") {
                    modalMonth = "jan";
                } else if (conditionCheck === "02") {
                    modalMonth = "feb";
                } else if (conditionCheck === "03") {
                    modalMonth = "mar";
                } else if (conditionCheck === "04") {
                    modalMonth = "apr";
                } else if (conditionCheck === "05") {
                    modalMonth = "may";
                } else if (conditionCheck === "06") {
                    modalMonth = "jun";
                } else if (conditionCheck === "07") {
                    modalMonth = "jul";
                } else if (conditionCheck === "08") {
                    modalMonth = "aug";
                } else if (conditionCheck === "09") {
                    modalMonth = "sep";
                } else if (conditionCheck === "10") {
                    modalMonth = "oct";
                } else if (conditionCheck === "11") {
                    modalMonth = "nov";
                } else {
                    modalMonth = "dec";
                }
                let conditionCheckYear = monthref[2];
                let modalYear = conditionCheckYear.substring(0, 4);
                if (month === modalMonth && year === modalYear) {
                    count = count + 1;
                }
                return null;
            });
        } else return false;
        return count;
    }
);

export const selectDashDetails = createSelector(
    [selectUsers, selectMachines, selectEquipments, selectDepartments, selectAllAreas, selectAreas, selectDept],
    (users, machines, equipments, departments = false, allAr = false , userAreas = false, userDepts = false ) => {
        
        if (users) {
            //get users belonging to logged in user areas & depts    
            let allAreas = allAr && Object.values(allAr).map((e)=> { return e })
            let allDepartments = departments && Object.values(departments).map((e)=> { return e })
            
            if(userAreas === false)
            {
                userAreas = allAreas
            }
            if(userDepts === false)
            {
                userDepts = allDepartments
            }
            let validationArea = []
            let validationDept = []
            let totalEmployees = _.compact(
                Object.keys(users).map(e => {
                    let refArray = []
                    let uid = e;
                    let deleted =
                        _.get(users[e], "profile.deleted") || false;
                    let areas = 
                        _.get(users[e], "profile.areas") || null
                    let departments = 
                        _.get(users[e], "profile.departments") || null 

                    if(areas === null ){
                        validationArea = _.intersection(allAreas,userAreas)
                    }else{
                        validationArea = _.intersection(areas,userAreas)
                    }

                    if(departments === null){
                        validationDept = _.intersection(allDepartments,userDepts)
                    }else {
                        validationDept = _.intersection(departments,userDepts)
                    } 

                    if (!deleted && validationArea.length !== 0 && validationDept.length !== 0) {
                        refArray.push({ uid })
                        return { uid};
                            
                    } else return null;
                })
            );
            
            let validMachinesArray = [];
            if(machines){
                Object.keys(machines).map(e => {
                    let areas = _.get(machines[e], "profile.areas") || null
                    let departments = _.get(machines[e], "profile.departments") || null 
                    if(areas === null ){
                        validationArea = _.intersection(allAreas,userAreas)
                    }else{
                        validationArea = _.intersection(areas,userAreas)
                    }
                    if(departments === null){
                        validationDept = _.intersection(allDepartments,userDepts)
                    }else {
                        validationDept = _.intersection(departments,userDepts)
                    } 
    
                    if (validationArea.length !== 0 && validationDept.length !== 0) {
                        validMachinesArray.push(machines[e]);
                    }
                    return null;
                })
            }

            let validEquipmentsArray = [];
            if(equipments){
                Object.keys(equipments).map(e => {
                    let areas = _.get(equipments[e], "profile.areas") || null
                    let departments = _.get(equipments[e], "profile.departments") || null 
                    if(areas === null ){
                        validationArea = _.intersection(allAreas,userAreas)
                    }else{
                        validationArea = _.intersection(areas,userAreas)
                    }
                    if(departments === null){
                        validationDept = _.intersection(allDepartments,userDepts)
                    }else {
                        validationDept = _.intersection(departments,userDepts)
                    } 
    
                    if (validationArea.length !== 0 && validationDept.length !== 0) {
                        validEquipmentsArray.push(equipments[e]);
                    }
                    return null;
                })
            }


            let totalMachines = machines ? Object.keys(validMachinesArray).length : 0;
            let totalQrs = equipments ? Object.keys(validEquipmentsArray).length : 0;
            return {
                totalMachines,
                totalQrs,
                totalEmployees: Object.keys(totalEmployees).length,
            };
        } else return false;
    }
);

export const selectReportsForExcel = createSelector(
    [
        selectAllReports,
        selectMonth,
        selectYear,
        // selectJobPackReports
    ],
    (
        allReports = false,
        month = moment().format("MMM").toLowerCase(),
        year = moment().format("YYYY"),
        // allJobPackReports = false,
        reportType = "custom_report"
    ) => {
        if (
            reportType &&
            reportType !== "all_categories" &&
            allReports &&
            reportType !== "vehicle_alerts"
        ) {
            let reports;

            if (allReports)
                reports = getReportsTemp(allReports, reportType, month, year);
            // if (allJobPackReports)
            //     jobPackReports = getJPReports(
            //         allJobPackReports,
            //         reportType,
            //         month,
            //         year
            //     );
            //     console.table(jobPackReports,"jobPackReports")
            if (
                Object.keys(reports).length === 0
                // Object.keys(jobPackReports).length === 0
            )
                return false;

            if (reports) {
                // if (reportType === "custom_report") {
                //     var finalArray = {};
                //     Object.values(reports).map((report) => {
                //         if (report.config === filterTemplate) {
                //             finalArray = _.assign(finalArray, {
                //                 [report.timestamp]: report,
                //             });
                //             return null;
                //         } else {
                //             return null;
                //         }
                //     });
                //     return [finalArray];
                // } else {

                return [reports];
                // }
            } else if (reports) {
                return [reports];
            } else if (!reports) {
                return;
            } else return false;
        } else return false;
    }
);

const getReportsTemp = (allReports, reportType, month, year) => {
    allReports = _.compact(
        Object.keys(allReports).map((e) => {
            return _.get(allReports[e], `reports.${reportType}`) || null;
        })
    );
    return [allReports];
};

/* Used Device Info */
export const selectUserDeviceData = createSelector(
    [selectUserDeviceInfo, selectYear, selectMonth],
    (userDeviceInfo, year, month) => {
        var androidVersionNames = { 4: "KitKat", 5: "lollioop", 6: "Marshmallow",7: "Nogat", 8: "Oreo", 9: "Pie", 10: "" ,11: "",  };
        let androidVersions = [];
        let androidBrand = [];
        let androidModel = [];
        Object.keys(userDeviceInfo).map((e) => {
            let userProfile = _.get(userDeviceInfo[e], "profile") || null;
            if(userProfile.last_active_device){
                androidVersions.push(userProfile.last_active_device.android_version);
                androidBrand.push(userProfile.last_active_device.brand);
                androidModel.push(userProfile.last_active_device.model);
            }
            return false;
        })

        var versionCounts = {};
        for (var i = 0; i < androidVersions.length; i++) {
            versionCounts[androidVersions[i]]  = 1 + (versionCounts[androidVersions[i]] || 0);
        }
        var brandCounts = {};
        for (var j = 0; j < androidBrand.length; j++) {
            brandCounts[androidBrand[j]]  = 1 + (brandCounts[androidBrand[j]] || 0);
        }
         var modelCounts = {};
         for (var k = 0; k < androidModel.length; k++) {
            modelCounts[androidModel[k]]  = 1 + (modelCounts[androidModel[k]] || 0);
         }
        
         //Random Colors
        var dynamicColors = function() {
            var randomColor = Math.floor(Math.random()*16777215).toString(16);
            return "#"+randomColor;

        };

        var versionCountKeys = [];
        var versionCountValues = [];
        var versionColors = [];
        for (var x in versionCounts){
            versionCountValues.push(versionCounts[x]);
            let y = parseInt(x);
            y = Math.trunc(y);
            y = 'Android '+x+' '+androidVersionNames[y];
            versionCountKeys.push(y);
            versionColors.push(dynamicColors())
            
        }

        var brandCountKeys = [];
        var brandCountValues = [];
        var brandColors = [];
        for (var z in brandCounts){
            brandCountValues.push(brandCounts[z]);
            brandCountKeys.push(z);
            brandColors.push(dynamicColors())
            
        }

        var modelCountKeys = [];
        var modelCountValues = [];
        var modelColors = [];
        for (var m in modelCounts){
            modelCountValues.push(modelCounts[m]);
            modelCountKeys.push(m);
            modelColors.push(dynamicColors())
            
        }

        const versionChart = {
            labels: versionCountKeys,
            datasets: [{data: versionCountValues,
                        backgroundColor : versionColors,
                        hoverBackgroundColor : versionColors,
                        borderColor: 'rgba(200, 200, 200, 0.75)',
                        hoverBorderColor: 'rgba(200, 200, 200, 1)'
            }],
        };

        const brandChart = {
            labels: brandCountKeys,
            datasets: [{data: brandCountValues,
                        backgroundColor: brandColors ,
                        hoverBackgroundColor: brandColors,
                        borderColor: 'rgba(200, 200, 200, 0.75)',
                        hoverBorderColor: 'rgba(200, 200, 200, 1)',
            }],
        };

        const modelChart = {
            labels: modelCountKeys,
            datasets: [{data: modelCountValues,
                        backgroundColor: modelColors ,
                        hoverBackgroundColor: modelColors,
                        borderColor: 'rgba(200, 200, 200, 0.75)',
                        hoverBorderColor: 'rgba(200, 200, 200, 1)',
            }],
        };
        const data = {versionChart : versionChart ,brandChart : brandChart, modelChart: modelChart }
        return data;
    }
);
// ------------------------------------------------------------------------------------------------------------------------
